import { useCallback } from 'react';
import { workflowApi } from '../core/services/api';

export type CommandKey = { system: string; objectType: string; action: string };
export type NormalizeMode = 'blur' | 'submit' | 'both' | 'none';

export type NormalizeResult = {
  resolved: Record<string, any>;
  missing?: Record<string, string>;
  invalid?: Record<string, string>;
};

export function useNormalize(key: CommandKey, mode: NormalizeMode = 'submit') {
  const normalize = useCallback(async (values: Record<string, any>, schema?: any): Promise<NormalizeResult> => {
    const resp: any = await workflowApi.normalizeParams(
      key.system,
      key.objectType,
      key.action,
      values,
      schema,
    );
    const resolved = resp?.resolved ?? values ?? {};
    const missing = resp?.missing ?? {};
    const invalid = resp?.invalid ?? {};
    return { resolved, missing, invalid };
  }, [key.system, key.objectType, key.action]);

  return { normalize, mode };
}
